/**
 * Realtime Event Names (msg.name)
 * These map to backend channel event categories
 */
export const REALTIME_EVENT = {
  STUDENT: "Student",
  SESSION: "Session",
  WHITEBOARD: "Whiteboard",
  TEACHER: "Teacher",
  HELPER: "Helper",
  TEAM: "Team",
} as const;

/**
 * Student Event Actions
 */
export enum StudentAction {
  RAISING_HAND = "RaisingHand",
  ENTER_CLASS = "EnterClass",
  LEAVE_SESSION = "LeaveSession",
  UPDATE_INDEPENDENT_EXPOSURE_ITEM = "UpdateIndependentExposureItem",
  STUDENT_MOVED_APP_TO_BACKGROUND = "StudentMovedAppToBackground",
}

/**
 * Whiteboard Event Actions
 */
export enum WhiteboardAction {
  TOGGLE_TARGET = "ToggleTarget",
}

/**
 * Teacher Event Actions
 */
export enum TeacherAction {
  UPDATE_ANNOTATION = "UpdateAnnotation",
  CLEAR_BOARD = "ClearBoard",
  UPDATE_STUDENT_BADGE = "UpdateStudentsBadge",
  UPDATE_STUDENT_PALETTE = "UpdateStudentPalette",
  REMOVE_HELPER = "RemoveHelper",
  CLEAR_RAISING_HAND = "ClearRaisingHand",
  SET_ONE_ONE = "SetOneOne",
  FAILED_SET_ONE_ONE = "FailedSetOneOne",
  SET_WHITEBOARD = "SetWhiteboard",
  SET_LESSON_ACTION = "SetLessonAction",
  TOGGLE_HELPER_VIDEO = "ToggleHelperVideo",
  TOGGLE_INDEPENDENT_MODE = "ToggleIndependentMode",
  UPDATE_CANVAS_OBJECT = "UpdateCanvasObject",
  UPDATE_MEDIA_STATE = "UpdateMediaState",
  UPDATE_EXPOSURE = "UpdateExposure",
  END_EXPOSURE = "EndExposure",
  SET_ANNOTATION_MODE = "SetAnnotationMode",
  SCROLL_PDF = "ScrollPdf",
  ZOOM_SLIDE = "ZoomSlide",
  MOVE_ZOOMED_SLIDE = "MoveZoomedSlide",
  TOGGLE_STUDENT_MEDIA_DEVICES = "ToggleStudentMediaDevices",
  SET_TEACHING_MODE = "SetTeachingMode",
  ENTER_CLASS = "EnterClass",
  END_SESSION = "EndSession",
}

/**
 * Session Event Actions
 */
export enum SessionAction {
  UPDATE_LESSON_AND_UNIT = "UpdateSessionLessonAndUnit",
}

/**
 * Helper Event Actions
 */
export enum HelperAction {
  SET_ONE_ONE = "SetOneOne",
  FAILED_SET_ONE_ONE = "FailedSetOneOne",
  REQUEST_TO_JOIN_SESSION = "RequestToJoinSession",
  CANCEL_REQUEST_TO_JOIN_SESSION = "CancelJoinSessionRequest",
  LEAVE_SESSION = "LeaveSession",
  TOGGLE_TEACHER_AUDIO = "ToggleTeacherAudio",
  ENTER_CLASS = "EnterClass",
  BECOME_TEACHER = "BecomeTeacher",
}

/**
 * Team Event Actions
 */
export enum TeamAction {
  TOGGLE_TEAM_MODE = "ToggleTeamMode",
  UPSERT_TEAM = "UpsertTeam",
}
